module.exports = __webpack_public_path__ + "img/Proliferation-BRCA_10X_IDC.7c075dd0.png";